import { render, staticRenderFns } from "./HnxIcon.vue?vue&type=template&id=40ec53e8&scoped=true&"
import script from "./HnxIcon.vue?vue&type=script&lang=js&"
export * from "./HnxIcon.vue?vue&type=script&lang=js&"
import style0 from "./HnxIcon.vue?vue&type=style&index=0&id=40ec53e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec53e8",
  null
  
)

component.options.__file = "HnxIcon.vue"
export default component.exports